import { Response } from '../models/general'
import { Baggage, TicketItem } from '../models/ticket'

import { clientApi } from './clientApi'

export enum ITariffStatuses {
  NO_INFO = 'no_info',
  PENALTY = 'penalty',
  AVAILABLE = 'available',
  NOT_AVAILABLE = 'not_available',
  ADDITIONAL_PAYMENT = 'additional_payment',
  INCLUDED = 'included',
  NOT_INCLUDED = 'not_included',
}

export interface IStatusTariff {
  status: ITariffStatuses
  info: string
}

export interface IDimensions {
  width: number
  length: number
  height: number
}

export interface ICbaggageTariff extends Baggage {
  dimensions: IDimensions
  weight_unit: string | null
}

export const TariffApi = {
  getTariffByTid(tid: string, signal: AbortSignal, uid: string, itRef: string) {
    return clientApi.get<Response<TicketItem[]>>(
      `/flights/fare_family?tid=${tid}&uid=${uid}&itref=${itRef}`,
      { signal: signal },
    )
  },
}
